import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热度榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时更新的黑料热度排名</p>
          </div>
          <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">
            每30分钟更新一次
          </span>
        </div>

        <div className="space-y-1">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-50 transition-colors group cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl font-black text-base flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400/80 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300/80 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                    item.tag === '爆'
                      ? 'bg-primary-500 text-background-50'
                      : item.tag === '热'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                  <span className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                )}
                {item.trend === 'down' && (
                  <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                )}
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap">{item.heat}</span>
                <span className="text-xs text-foreground-400">热度</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}